import React from 'react';

type Option = {
  key: string;
  label: string;
  icon: React.ReactNode;
};

type Props = {
  top: number;
  left: number;
  onClose: () => void;
  onSelect?: (key: string) => void;
};

const options: Option[] = [
  {
    key: 'heading',
    label: 'Heading',
    icon: (
      <svg className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M6 4v16"/><path d="M18 4v16"/><path d="M6 12h12"/></svg>
    ),
  },
  {
    key: 'subheading',
    label: 'Subheading',
    icon: (
      <svg className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 8h16"/><path d="M8 16h8"/></svg>
    ),
  },
  {
    key: 'paragraph',
    label: 'Paragraph',
    icon: (
      <svg className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 7h16"/><path d="M4 12h12"/><path d="M4 17h10"/></svg>
    ),
  },
  {
    key: 'button',
    label: 'Button',
    icon: (
      <svg className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="4" y="8" width="16" height="8" rx="4"/></svg>
    ),
  },
  {
    key: 'divider',
    label: 'Divider',
    icon: (
      <svg className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 12h16"/></svg>
    ),
  },
];

const QuickAddPopup: React.FC<Props> = ({ top, left, onClose, onSelect }) => {
  return (
    <div
      className="fixed z-[2100] w-64 rounded-xl border border-gray-200 bg-white/95 backdrop-blur shadow-xl"
      style={{ top, left }}
      onClick={(e) => { e.stopPropagation(); }}
    >
      <div className="flex items-center justify-between px-3 pt-3">
        <div className="text-sm font-medium text-gray-900">Quick add</div>
        <button
          className="h-7 w-7 inline-flex items-center justify-center rounded-full hover:bg-gray-50"
          onClick={(e) => { e.preventDefault(); e.stopPropagation(); onClose(); }}
          title="Close"
          aria-label="Close quick add"
        >
          <svg className="h-4 w-4 text-gray-500" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M18 6L6 18"/><path d="M6 6l12 12"/></svg>
        </button>
      </div>
      <div className="px-3 pb-3">
        <div className="text-xs text-gray-500 mb-2">Choose what to insert</div>
        <div className="grid grid-cols-2 gap-2">
          {options.map(opt => (
            <button
              key={opt.key}
              className="group flex items-center gap-2 p-2 rounded-lg border border-gray-200 hover:border-blue-300 bg-white hover:bg-blue-50 text-gray-800 hover:text-blue-700 transition"
              onClick={(e) => { e.preventDefault(); e.stopPropagation(); if (onSelect) onSelect(opt.key); }}
              title={opt.label}
            >
              <span className="inline-flex items-center justify-center h-7 w-7 rounded-md bg-gray-50 group-hover:bg-blue-100 border border-gray-200 group-hover:border-blue-200 text-gray-700 group-hover:text-blue-700">
                {opt.icon}
              </span>
              <span className="text-sm font-medium">{opt.label}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default QuickAddPopup;
